<template>
  <footer class="footer">
    <div class="wrap">
      <div class="footer-left">
        <div class="footer-logo">
          <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__logo.png" data-img-pc="https://www.payeasy.com.tw/hotel/Content/images/footer__logo.png" data-img-mobile="https://www.payeasy.com.tw/hotel/Content/images/footer__logo--m.png">
          <a class="footer-logo-fb" href="https://www.facebook.com/payeasytravel" target="_blank" @click="clickGA('FaceBook')"></a>
          <a class="footer-logo-ig" href="https://www.instagram.com/love_travel_payeasy/" target="_blank" @click="clickGA('Instagram')"></a>
        </div>
        <div class="footer-name">PayEasy 康迅旅行社股份有限公司</div>
        <div class="clearfix">
          <div class="footer-company">
            <div>交觀甲字6837</div>
            <div>代表人 李易騰</div>
            <div>聯絡人 林佳美</div>
          </div>
          <div class="footer-contact">
            <div>100台北市中正區仁愛路二段2號3樓</div>
            <div>公司代表號：(02)3322-3822</div>
            <div>
              周一至周五 09:00 - 18:00
              <span class="visible-sm-inline visible-xs-inline">
                <br>
              </span>
              客服專線：
              <a href="tel:0255691617">(02)5569-1617</a>
            </div>
            <div>
              <a href="mailto:payeasytravel@payeasy.com.tw" target="_top">payeasytravel@payeasy.com.tw</a>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-right">
        <div class="footer-awards visible-md visible-lg">
          <a href="http://www.travel.org.tw/" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award0.png">
          </a>
          <a href="http://www.tata.org.tw/news/index.jsp" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award1.png">
          </a>
          <a href="http://travel.nccc.com.tw/NASApp/NTC/servlet/com.du.mvc.EntryServlet?Action=RetailerEdit&amp;Type=GetFull&amp;Id=84517&amp;RequestType=0&amp;WebMode=" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award2.png">
          </a>
          <a href="http://www.payeasy.com.tw/taiwanrice/edm/030/edm.htm" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award3.png">
          </a>
          <a href="http://www.payeasy.com.tw/pay_event/event_08/superiorbrands/" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award4.png">
          </a>
          <a href="https://ssl2.twca.com.tw/NCWebSSL/certinfo.htm?DNS=*.payeasy.com.tw&SerialNumber=95553839087618624193705924550004057714" target="_blank">
            <img src="https://www.payeasy.com.tw/hotel/Content/images/footer__award5.png">
          </a>
        </div>
        <div class="footer-copyright">
          <div>PayEasy採用銀行等級之SSL 256bit安全電子交易機制，以高規格標準保護會員資料安全。</div>
          <div>©2016 PayEasy旅遊 Digital Integration CO., LTD. All Rights Reserved.</div>
          <div>
            <!-- <a href="https://developer.ean.com/terms/zh" target="_blank" class="underline">訂房服務條款</a> -->
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  methods: {
    clickGA (slotDetail) {
      window.dataLayer.push({
        event: 'click_button',
        main_page: 'PC Travel all', // 主要頁面
        slot: '粉絲專頁', // 版位
        slot_detail: slotDetail // 版位細項
      })
    }
  }
}
</script>
<style lang="scss">
.footer {
  padding: 25px 20px;
  background: #eee;
  color: #88888d;
}

.footer::after,
.footer::before {
  display: table;
  content: "";
}

.footer::after {
  clear: both;
}

.footer .wrap {
  max-width: 1280px;
  padding: 0 15px;
  margin: auto;
}

.footer-left {
  float: left;
  font-size: 14px;
}

.footer-right {
  float: right;
  font-size: 12px;
}

.footer-name {
  margin-bottom: 10px;
  font-weight: 700;
}

.footer-company {
  margin-right: 30px;
  float: left;
}

.footer-contact {
  float: left;
}

.footer-awards {
  margin-top: 35px;
}

.footer a {
  color: #88888d;
  text-decoration: none;
}

.footer a.underline {
  text-decoration: underline;
}

.footer-copyright {
  margin-top: 15px;
}

.footer-copyright div {
  margin-bottom: 5px;
}
.footer-logo::after {
  content: "";
  display: table;
  clear: both;
}
.footer-logo > img {
  float: left;
}
.footer-logo-fb {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-image: url("~@/assets/images/footer-icon-fb.svg");
  background-size: cover;
  background-color: #9d9d9d;
  transition: 0.2s ease-in-out;
  margin: 0 3px;
}
.footer-logo-fb:hover {
  background-color: #3b5998;
}
.footer-logo-ig {
  display: inline-block;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: url("~@/assets/images/footer-icon-ig.svg") center;
  background-size: cover;
  background-color: #9d9d9d;
  transition: 0.2s ease-in-out;
  margin: 0 3px;
}
.footer-logo-ig:hover {
  background: url("~@/assets/images/footer-icon-ig.svg"),
    url("~@/assets/images/footer-icon-ig.png");
  background-color: none;
}
@media (max-width: 991px) {
  .footer {
    font-size: 14px;
  }

  .footer-left,
  .footer-right {
    float: none;
    font-size: 12px;
  }

  .footer-logo img {
    max-width: 200px;
    width: 50vw;
  }
  .footer-logo-fb,
  .footer-logo-ig {
    width: 40px;
    height: 40px;
  }
  .footer-name {
    margin-bottom: 15px;
  }

  .footer-contact {
    color: #666;
    font-size: 14px;
  }

  .footer-contact a {
    color: #666;
  }

  .footer-company {
    margin-right: 15px;
  }
}
</style>



// WEBPACK FOOTER //
// src/layouts/Footer.vue